import { useEffect, useState } from "react";

const OfficeBIandAView = ({ data }) => {
  const [details, setDetails] = useState({});
  useEffect(() => {
    setDetails({
      BMO: ["BMO", data?.bmoName],
      OfficeDivision: ["Office Division", data.officeDivisionName],
      NationalCampaignBillingCode: [
        "National Campaign Billing Code",
        data.nationalCampaignBillingCode,
      ],
      GLBranch: [
        "GL Branch",
        data.glBranch ? data.glBranch + "-" + data.glEntityName : "",
      ],
      TexasGrouping: ["Texas Grouping", data.texasGroupingName],
      StateForReporting: ["State for Reporting", data.stateForReporting],
      OfficeDepartment: ["Office Department", data.officeDepartmentName],
    });
  }, []);

  return (
    <div className="w-full">
      <div className="grid text-xs px-2 py-1 gap-y-1 grid-cols-2">
        {Object.values(details).map((item, i) => {
          return (
            <div key={i} className="w-full border-b border-gray-200 py-1">
              <div className="grid grid-cols-3">
                <div className="expandedLabel fontExpand text-left">
                  <span>{item[0]}:</span>
                </div>
                <span className="expandedData fontExpand col-span-2">
                  {item[1] === null || item[1] === "NULL" ? "" : item[1]}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default OfficeBIandAView;
